import { useCreateResourceGroupMutation } from '@/queries/resourceGroups.queries';
import { useListResourcesQuery } from '@/queries/resources.queries';
import IResource from '@/types/IResource';
import IResourceGroup from '@/types/IResourceGroup';
import { useToast } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { object, string } from 'yup';

const schema = object({
	email: object().shape({ label: string().required(), value: string().required() }),
});

interface IArgs {
	resourceGroup: IResourceGroup;
	isOpen: boolean;
	close: () => void;
}

export function useAddMemberToGroupModal(args: IArgs) {
	const updateGroupMutation = useCreateResourceGroupMutation();
	const availabilitiesQuery = useListResourcesQuery();
	const toast = useToast();
	const { t } = useTranslation();

	const form = useForm({
		defaultValues: { email: { label: '', value: '' } },
		resolver: yupResolver(schema),
	});

	const handleSubmit = form.handleSubmit((values) => {
		const newResource = availabilitiesQuery.data?.resources.find((r) => r.id === values.email.value) as IResource;

		if (!newResource) {
			return;
		}

		return updateGroupMutation
			.mutateAsync({
				...args.resourceGroup,
				resources: [...args.resourceGroup.resources, newResource],
			})
			.then(() => {
				toast({
					isClosable: true,
					status: 'success',
					title: t('Success'),
				});
				form.reset();
				args.close();
			});
	});

	return {
		availabilitiesQuery,
		form,
		handleSubmit,
		t,
	};
}
